import { Link } from 'react-router-dom';

export default function BlogFooter() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <section>
            <h4 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              <strong>Urban Spaces</strong>
            </h4>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Transforming spaces into extraordinary experiences through innovative design and digital solutions.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-facebook-line"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-500 transition-colors cursor-pointer">
                <i className="ri-twitter-line"></i>
              </a>
            </div>
          </section>

          <nav>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/?section=services" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/?section=portfolio" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/?section=blog" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
            </ul>
          </nav>

          <section>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-300">Interior Design</li>
              <li className="text-gray-300">Web Development</li>
              <li className="text-gray-300">Brand Identity</li>
              <li className="text-gray-300">Digital Strategy</li>
              <li className="text-gray-300">Consultation</li>
            </ul>
          </section>

          <section>
            <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-teal-400"></i>
                </div>
                <span className="text-gray-300">D-503, Capital Crown, Nr. Raysan Metro Station, Raysan, Gujarat, India - 382426</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-teal-400"></i>
                </div>
                <a href="mailto:enquiryurbanspaces@gmail.com" className="text-gray-300 hover:text-teal-400 transition-colors">
                  enquiryurbanspaces@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-teal-400"></i>
                </div>
                <a href="tel:+919925898625" className="text-gray-300 hover:text-teal-400 transition-colors">
                  +91 99258 98625
                </a>
              </li>
            </ul>
          </section>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2024 <strong>Urban Spaces</strong>. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <div>
                <h4 className="text-white font-semibold mb-4">Legal</h4>
                <div className="space-y-2">
                  <Link to="/privacy-policy" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Privacy Policy</Link>
                  <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Terms of Service</a>
                </div>
              </div>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}